export default class RequirementModel {
  public points: number = null;
  public gameParticipationCount: number = null;
  public entityId: string = null;
  public entityType: "competition" | "team" | null = null;
  public predictionsMade: number = null;
  public correctPredictions: number = null;
}
